import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Typography, Grid, Button } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LabelIcon from '@mui/icons-material/Label';

const WriterHome = () => {
  const navigate = useNavigate();

  const options = [
    {
      title: "All Blogs",
      icon: <PostAddIcon fontSize="large" />,
      action: () => navigate("/writer/blogs"),
    },
    {
      title: "All Skills",
      icon: <AddCircleOutlineIcon fontSize="large" />,
      action: () => navigate("/writer/skills"),
    },
    {
      title: "See All Posts",
      icon: <ListAltIcon fontSize="large" />,
      action: () => navigate("/writer/posts"),
    },
  ];

  return (
    <div className="container py-5">
      <Typography variant="h4" gutterBottom>
        Writer Home
      </Typography>
      <Grid container spacing={3}>
        {options.map((option, idx) => (
          <Grid item xs={12} sm={6} md={3} key={idx}>
            <Card
              sx={{
                minHeight: 180,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              }}
              onClick={option.action}
            >
              <CardContent>
                {option.icon}
                <Typography variant="h6" mt={2}>
                  {option.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default WriterHome;
